export default function menu() {

 /*   function insertAfter(newElement, referenceElement) {
        referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling);
    }

    let navigation = document.querySelector('.navigation'),
    hiding = document.querySelector('.hiding'),
    contacts = document.querySelector('.contacts');

    hiding.style.top = navigation.offsetHeight + "px";
    contacts.style.top = navigation.offsetHeight + "px";

    window.addEventListener('resize', function () {
        let navigation = document.querySelector('.navigation'),
            hiding = document.querySelector('.hiding'),
            contacts = document.querySelector('.contacts');

        hiding.style.top = navigation.offsetHeight + "px";
        contacts.style.top = navigation.offsetHeight + "px";
    })


    navigation.querySelectorAll('li.menu-item-has-children').forEach(item => {
        item.addEventListener('mouseover', (e) => {
            hiding.classList.add('hiding--active');
        });
        item.addEventListener('mouseleave', (e) => {
            hiding.classList.remove('hiding--active');
        });
    })*/


    let burger = document.querySelector('.menu-toggle'),
        menu_container = document.querySelector('.header__menu'),
        body = document.querySelector('body'),
        burger_status = false;

    burger.addEventListener('click', (e) => {
        e.preventDefault();
        if (!burger.classList.contains('menu-toggle--active')) {
            burger.classList.add('menu-toggle--active');
            burger_status = true;
        } else {
            burger.classList.remove('menu-toggle--active')
            burger_status = false;
        }
        if (burger_status) {
            menu_container.classList.add('header__menu--active')
            body.classList.add('overflow-h');
        } else {
            menu_container.classList.remove('header__menu--active')
            body.classList.remove('overflow-h');
        }
    })

    let menu = document.querySelector('.main-menu');

    document.querySelectorAll('.toggler')
        .forEach(toggler => {
            toggler.addEventListener('click', (e) => {
                e.preventDefault();
                let parent = toggler.closest('.menu-item-has-children');
                if (!parent.classList.contains('active')) {
                    parent.classList.add('active');
                } else {
                    parent.classList.remove('active')
                }

            })
        })

}